import {AnyAction} from "redux";
import {SET_SEASON, SHOW_NEXT_OUTAGE_QUESTION, SHOW_QUESTION} from "../actions/action";
import * as _ from 'lodash';
import {createSelector} from "reselect";
import {getSeasonsData, ISeason} from "../../data/data";


//  define selectors

export const getSeasonID = state => state.season;


/**
 * get the data object for a season
 */
export const getSeasonData = createSelector(

    [getSeasonID],

    (season_id: string) : ISeason =>
    {
        const seasons: ISeason[] = getSeasonsData();

        return _.find(seasons, ['id', season_id])
    }
);


/**
 * get the index of a season
 */
export const getSeasonIndex = createSelector(

    [getSeasonID],

    (season_id: string) : number =>
    {
        const seasons: ISeason[] = getSeasonsData();

        return _.findIndex(seasons, ['id', season_id])
    }
);

//  define the initial state

const initialState: string = _.get(getSeasonsData(), '[0].id');


/**
 * reducer: set the current season ID
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export function season(state: string = initialState, action: AnyAction): string
{
    switch (action.type)
    {
        case SET_SEASON:
        {
            const {payload} = action;
            const {season_id} = payload;

            return season_id;
        }

        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/season.ts